// extracted by mini-css-extract-plugin
export default {"formDivider":"n4LtG6GB","gridContainer":"jWIb4St8","formItem":"nSdYMFA4","reviewSideContainer":"Uz377aDR","pageReviewContainer":"wnb2nMBY"};